import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoginController from '../Controllers/LoginController';
import Logo from '../logo.png';

const Login = () => {
  const { auth, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [usernameOrEmail, setUsernameOrEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (auth?.token) {
      const from = location.state?.from?.pathname || '/dashboard';
      navigate(from, { replace: true });
    }
  }, [auth, navigate, location]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage('');
    setErrorMessage('');
    setLoading(true);

    await LoginController.loginUser(
      { email: usernameOrEmail, password },
      (token) => {
        login(token);
        const from = location.state?.from?.pathname || '/dashboard';
        navigate(from, { replace: true });
      },
      setMessage,
      setErrorMessage
    );

    setLoading(false);
  };

  return (
    <div className="container-fluid page-body-wrapper full-page-wrapper">
      <div className="content-wrapper d-flex align-items-center auth px-0">
        <div className="row w-100 m-auto">
          <div className="col-lg-4 mx-auto">
            <div className="auth-form-light text-center py-5 px-sm-5">
              <div className="brand-logo">
                <img src={Logo} alt="logo" />
              </div>
              <h6 className="font-weight-light">Sign in to continue.</h6>

              {message && (
                <div className="alert alert-info">{message}</div>
              )}
              {error && !Array.isArray(error) && typeof error === 'string' && (
                <div className="alert alert-warning">{error}</div>
              )}

              <form onSubmit={handleLogin} className="pt-3">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    placeholder="Username or Email"
                    value={usernameOrEmail}
                    onChange={(e) => setUsernameOrEmail(e.target.value)}
                    required
                    autoComplete="username"
                  />
                  {error?.email && (
                    <span className="text text-danger">{error.email}</span>
                  )}
                </div>

                <div className="form-group">
                  <input
                    type="password"
                    className="form-control form-control-lg"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    autoComplete="current-password"
                  />
                  {error?.password && (
                    <span className="text text-danger">{error.password}</span>
                  )}
                </div>

                <div className="mt-3">
                  <button
                    type="submit"
                    className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm mr-2" role="status" />
                        Signing in…
                      </>
                    ) : (
                      <>
                        <i className="bi bi-box-arrow-in-right mr-1"></i> Sign In
                      </>
                    )}
                  </button>
                  <div className="text-center mt-4 font-weight-light">
                    Don't have an account?{' '}
                    <NavLink className="text-muted font-weight-bold" to="/register">
                      <i className="bi bi-box-arrow-in-down-right ml-1"></i> Let's Join?
                    </NavLink>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
